import { useReducer } from 'react';
import { useClient } from '../../../context/client';
import { useAsyncEffect } from '../../../hooks';
import {
	initialState as productFiltersInitialState,
	loadProductTypes,
} from './productsSearchSlices/productFiltersSlice';
import searchSlice, {
	initialState as searchInitialState,
} from './productsSearchSlices/searchSlice';
import {
	initialState as vehicleFiltersInitialState,
	loadVehicleTree,
} from './productsSearchSlices/vehicleFiltersSlice';

export default function useProductsSearchStore() {
	const client = useClient();
	const [state, dispatch] = useReducer(searchSlice, {
		search: searchInitialState,
		filters: {
			vehicle: vehicleFiltersInitialState,
			product: productFiltersInitialState,
		},
	});

	useAsyncEffect(async () => {
		const [productTypes, vehicleTree] = await Promise.all([
			client.getProductTypes(),
			client.getVehicles(),
		]);

		dispatch(loadProductTypes(productTypes));
		dispatch(loadVehicleTree(vehicleTree));
	});

	return [state, dispatch];
}
